import { useEffect, useState } from 'react';
import { api } from '../utils/api';
import { useAuth } from '../context/AuthContext';

export default function Conquistas() {
  const { token } = useAuth();
  const [conquistas, setConquistas] = useState([]);
  const [operacoes, setOperacoes] = useState([]);
  const [opSelecionada, setOpSelecionada] = useState('');

  useEffect(() => {
    api.get('/operacoes', token).then(ops => {
      setOperacoes(ops);
      if (ops.length > 0) setOpSelecionada(ops[0].id);
    }).catch(console.error);
  }, [token]);

  useEffect(() => {
    const url = opSelecionada ? `/conquistas?operacao_id=${opSelecionada}` : '/conquistas';
    api.get(url, token).then(setConquistas).catch(console.error);
  }, [token, opSelecionada]);

  const desbloqueadas = conquistas.filter(c => c.desbloqueada_em);
  const pct = conquistas.length ? Math.round(desbloqueadas.length / conquistas.length * 100) : 0;

  return (
    <div style={{padding:'28px 32px'}}>
      <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',marginBottom:24,flexWrap:'wrap',gap:12}}>
        <div>
          <div style={{fontSize:22,fontWeight:700,letterSpacing:'-.02em'}}>Conquistas</div>
          <div style={{fontSize:13,color:'#6B7289',marginTop:3}}>{desbloqueadas.length} de {conquistas.length} medalhas desbloqueadas</div>
        </div>
        {operacoes.length > 0 && (
          <select value={opSelecionada} onChange={e=>setOpSelecionada(e.target.value)}
            style={{padding:'9px 14px',border:'1px solid #E4E6EF',borderRadius:8,fontSize:13,outline:'none',background:'#fff',maxWidth:260}}>
            {operacoes.map(op => <option key={op.id} value={op.id}>{op.nome}</option>)}
          </select>
        )}
      </div>

      <div className="card" style={{marginBottom:20,padding:16}}>
        <div style={{display:'flex',justifyContent:'space-between',marginBottom:8}}>
          <span style={{fontSize:13,fontWeight:500}}>Seu progresso</span>
          <span style={{fontSize:13,fontWeight:700,color:'#1A2ECC'}}>{pct}%</span>
        </div>
        <div className="progress-bar" style={{height:6}}>
          <div className="progress-fill" style={{width:pct+'%'}} />
        </div>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))',gap:14}}>
        {conquistas.map(c => {
          const earned = !!c.desbloqueada_em;
          return (
            <div key={c.id} className="card" style={{
              textAlign:'center',padding:20,
              opacity: earned ? 1 : 0.5,
              filter: earned ? 'none' : 'grayscale(1)',
              borderColor: earned ? '#F0C52A' : '#E4E6EF',
              background: earned ? '#FFFBEB' : '#fff',
            }}>
              <div style={{fontSize:32,marginBottom:10}}>{c.icone}</div>
              <div style={{fontSize:12,fontWeight:600,color:'#0B0E1A',marginBottom:4}}>{c.nome}</div>
              <div style={{fontSize:11,color:'#6B7289',lineHeight:1.4}}>{c.descricao}</div>
              {earned && (
                <div style={{fontSize:10,color:'#0FA36B',marginTop:8,fontWeight:500}}>
                  ✓ {new Date(c.desbloqueada_em).toLocaleDateString('pt-BR')}
                </div>
              )}
              {!earned && <div style={{fontSize:10,color:'#9095A8',marginTop:8}}>Bloqueada</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
